// Подсветка счётчика, который растёт прямо сейчас.
//
// Ненулевой счётчик сам по себе ни о чём не говорит: один срыв на старте, пока
// сервер прогревался, горел бы красным всю сессию, и к подсветке быстро бы
// привыкли. Горит только тот, что вырос за последние секунды, — то есть
// проблема, которая идёт сейчас.

/** Сколько держать подсветку после последнего роста. */
export const HOT_WINDOW_MS = 5_000;

export interface Trend {
  value: number;
  /** Когда счётчик рос в последний раз; `-Infinity` — не рос никогда. */
  changedAt: number;
}

export function freshTrend(): Trend {
  return { value: 0, changedAt: -Infinity };
}

/**
 * Учесть новое значение. Падение — это новая сессия со счётчиками с нуля, а не
 * событие, и подсветки не даёт.
 */
export function observe(trend: Trend, value: number, now: number): void {
  if (value > trend.value) {
    trend.changedAt = now;
  }
  trend.value = value;
}

export function isHot(trend: Trend, now: number): boolean {
  return now - trend.changedAt < HOT_WINDOW_MS;
}
